<div class="MainContainer">

    <!-- Compact Filter Bar: Period + Dates + Filter button + Page badge -->
    <div class="CompactFilterBar">
      <div class="FilterBarLeft">
        <!-- Period Dropdown (no Angular Material) -->
        <div class="CustomDropdownContainer" style="width: 140px; flex: 0 0 140px; margin: 0 4px 0 0;">
          <div class="DropdownOverlayTransparent" *ngIf="showPeriodDropdown" (click)="showPeriodDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showPeriodDropdown = !showPeriodDropdown;" style="height: 32px;">
            <i class="material-icons dropdown-icon-left" style="font-size: 14px;">date_range</i>
            <span class="CustomDropdownInput" [class.placeholder]="!Filter.Period?.Name" style="font-size: 10px;">{{Filter.Period?.Name || ('Receptions.ChoosePeriod' | translate)}}</span>
            <i class="material-icons dropdown-icon" style="font-size: 16px;">expand_more</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPeriodDropdown">
            <div class="CustomDropdownResult" *ngFor="let a of this.Periods" (click)="Filter.Period = a; AddActiveFilter(a.Name, 'Period'); showPeriodDropdown = false; GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Name}}</span></div>
            </div>
          </div>
        </div>

        <!-- From Date -->
        <div class="PopupFormRow" style="margin: 0; width: 140px; flex: 0 0 140px;">
          <input type="date" class="PopupFormInput" style="height: 32px; font-size: 11px; border-radius: 40px; padding: 0 10px;" [value]="Filter.FromDate | date:'yyyy-MM-dd'" (change)="Filter.FromDate = $event.target.value; FromDate.setValue($event.target.value); ClearPeriod();" placeholder="{{'Receptions.FromDate' | translate}}">
        </div>

        <!-- To Date -->
        <div class="PopupFormRow" style="margin: 0; width: 140px; flex: 0 0 140px;">
          <input type="date" class="PopupFormInput" style="height: 32px; font-size: 11px; border-radius: 40px; padding: 0 10px;" [value]="Filter.ToDate | date:'yyyy-MM-dd'" (change)="Filter.ToDate = $event.target.value; ToDate.setValue($event.target.value); ClearPeriod();" placeholder="{{'Receptions.ToDate' | translate}}">
        </div>

        <div class="CompactFilterButton" (click)="GetCashCollectionsFiltered();">
          <i class="material-icons">filter_alt</i>
          <span>{{ 'Filter' | translate }}</span>
        </div>

        <div class="PageTitleBadge">
          <i class="material-icons">account_balance_wallet</i>
          <span>{{ 'CashCollections' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Actions Row: Buttons + Search -->
    <div class="ActionsFilterRow">
      <div class="LeftActions">
        <div class="FilterButton" (click)="GetShippingCompanies();AdjustShippingTransferListBankAccount();">
          <i class="material-icons">local_shipping</i>
          <span>{{'ImportShippingCompanyTransferList' | translate}}</span>
        </div>
        <div class="FilterButton" (click)="OpenBankExtrasImport();">
          <i class="material-icons">account_balance</i>
          <span>{{'ImportBankExtras' | translate}}</span>
        </div>
        <div class="FilterButton" style="border-color: #00c9bd;" (click)="InitializeNewCashCollectionCCPage();">
          <i class="material-icons" style="color: #00c9bd;">add</i>
          <span>{{'CashCollection' | translate}}</span>
        </div>
        <div class="FilterButton" style="border-color: #4caf50;" (click)="ExportCashCollectionsValues();">
          <i class="material-icons" style="color: #4caf50;">file_download</i>
          <span>{{'Export' | translate}}</span>
        </div>
      </div>

      <div class="MainOrdersSearchContainer">
        <input type="text" class="MainOrdersSearch" placeholder="{{'Search' | translate}}" [(ngModel)]="this.Filter.SearchTerm" (keydown.enter)="GetCashCollectionsFiltered();">
        <i class="material-icons" *ngIf="!(this.Filter?.SearchTerm?.length > 0);" (click)="GetCashCollectionsFiltered();">search</i>
        <i class="material-icons" *ngIf="this.Filter?.SearchTerm?.length > 0;" (click)="this.Filter.SearchTerm = ''; GetCashCollectionsFiltered();">close</i>
      </div>
    </div>

    <!-- Step 2: Import Cash Collections Popup -->
    <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowSuggestionCashCollectionsContainerStepTwo" (click)="ShowSuggestionCashCollectionsContainerStepTwo = false;"></div>
    <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" *ngIf="ShowSuggestionCashCollectionsContainerStepTwo">
      <div class="ConvertPopupHeader">
        <div class="ConvertPopupIconWrapper" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%);">
          <i class="material-icons">cloud_upload</i>
        </div>
        <div class="ConvertPopupHeaderText">
          <span class="ConvertPopupTitle">{{ 'IMPORTCASHCOLLECTIONS' | translate }}</span>
        </div>
        <i class="material-icons ConvertPopupClose" (click)="ShowSuggestionCashCollectionsContainerStepTwo = false;">close</i>
      </div>
      <div class="ConvertPopupBody" style="text-align: left; padding: 16px 20px;">
        <div class="PopupFormInfoBadge success">
          <i class="material-icons" style="font-size: 16px;">check_circle</i>
          {{'AssociatedCashCollections' | translate}}: {{this.AssociatedCashCollections?.length}}
        </div>
        <div class="PopupFormInfoBadge danger">
          <i class="material-icons" style="font-size: 16px;">warning</i>
          {{'UnAssociatedCashCollections' | translate}}: {{this.UnAssociatedCashCollections?.length}}
        </div>

        <div class="PopupFormRow" style="margin-top: 14px;">
          <label class="PopupFormLabel">{{'PickImportType' | translate}}</label>
          <div class="PopupRadioGroup">
            <div class="PopupRadioItem" *ngFor="let type of this.CashCollectImportTypes" [class.selected]="CCImportType?.ID === type.ID" (click)="CCImportType = type;">
              <i class="material-icons">{{CCImportType?.ID === type.ID ? 'radio_button_checked' : 'radio_button_unchecked'}}</i>
              {{type.Name}}
            </div>
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 10px; margin-top: 12px; padding: 10px 12px; background: #fff8f0; border: 1px solid #ffe0b2; border-radius: 8px;">
          <label class="MiniToggle" style="flex-shrink: 0;">
            <input type="checkbox" [(ngModel)]="DoNotImportDupplicateValues">
            <span class="MiniToggleSlider"></span>
          </label>
          <div style="display: flex; flex-direction: column;">
            <span style="font-size: 11px; font-weight: 600;" [style.color]="DoNotImportDupplicateValues ? '#2e7d32' : '#c62828'">
              {{DoNotImportDupplicateValues ? ('DoNotImportDupplicateValues' | translate) : ('DupplicateValuesWillBeImported' | translate)}}
            </span>
          </div>
        </div>
      </div>
      <div class="ConvertPopupFooter">
        <button class="ConvertPopupNoBtn" (click)="ShowSuggestionCashCollectionsContainerStepTwo = false;">{{ 'Cancel' | translate }}</button>
        <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%) !important;" [disabled]="parent.loading" (click)="ImportCashCollections();">
          <i class="material-icons">cloud_upload</i>
          {{'AcceptAndSave' | translate}}
        </button>
      </div>
    </div>

    <!-- Detected CC Overlay -->
    <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowSuggestionCashCollectionsContainer" (click)="ShowSuggestionCashCollectionsContainer = false;"></div>

    <div class="DetectedCCPopup" *ngIf="ShowSuggestionCashCollectionsContainer">
        <!-- ConvertPopup Header -->
        <div class="ConvertPopupHeader">
          <div class="ConvertPopupIconWrapper">
            <i class="material-icons">playlist_add_check</i>
          </div>
          <div class="ConvertPopupHeaderText">
            <span class="ConvertPopupTitle">{{ 'DetectedCashCollections' | translate }}</span>
          </div>
          <i class="material-icons ConvertPopupClose" (click)="ShowSuggestionCashCollectionsContainer = false;">close</i>
        </div>

        <!-- GridModeTabsWrapper - Apple Segmented Control -->
        <div class="GridModeTabsWrapper">
          <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': activeDetectedTab === 'associated'}" (click)="activeDetectedTab = 'associated'">
            <i class="material-icons">check_circle</i>
            <span>{{'AssociatedCashCollections' | translate}}</span>
            <span class="TabBadge">{{getDetectedCountByStatus(1)}}</span>
          </div>
          <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': activeDetectedTab === 'unassociated'}" (click)="activeDetectedTab = 'unassociated'">
            <i class="material-icons">help_outline</i>
            <span>{{'UnAssociatedCashCollections' | translate}}</span>
            <span class="TabBadge">{{getDetectedCountByStatus(-1)}}</span>
          </div>
        </div>

        <!-- COLLECTION GROUPS VIEW -->
        <div class="DetectedCCPopupBody">
          <div *ngIf="loading" style="text-align:center;padding:30px;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div *ngIf="!loading">
            <ng-container *ngFor="let group of this.CollectionGroups;">

              <!-- Filter by active tab -->
              <ng-container *ngIf="isGroupVisibleForTab(group, activeDetectedTab)">

              <!-- Group Card -->
              <div class="CGCard" (click)="group.IsExpanded = !group.IsExpanded">
                <!-- Group Header -->
                <div class="CGHeader">
                  <i class="material-icons CGExpandIcon">{{group.IsExpanded ? 'expand_more' : 'chevron_right'}}</i>
                  <i class="material-icons" style="color: #00c9bd; font-size: 18px;">account_balance</i>
                  <div class="CGHeaderInfo">
                    <span class="CGHeaderClient">{{group.Client?.Name || ('UnAssociatedCashCollections' | translate)}}</span>
                    <span class="CGHeaderMeta">{{group.CollectionDateUI}} · {{group.Collections.length}} {{'CashCollections' | translate}}</span>
                  </div>
                  <div class="CGHeaderValues">
                    <div class="CGHeaderTotal">
                      <span class="CGHeaderTotalLabel">Total</span>
                      <span class="CGHeaderTotalValue">{{group.OriginalValue | number:'1.2-2'}} {{group.Currency?.Name}}</span>
                    </div>
                    <div class="CGHeaderUnallocated" [ngClass]="{'CGHeaderUnallocatedZero': group.UnallocatedValue == 0}">
                      <span class="CGHeaderTotalLabel">{{'Unallocated' | translate}}</span>
                      <span class="CGHeaderUnallocatedValue" [style.color]="group.UnallocatedValue > 0 ? '#f44336' : '#2e7d32'">{{group.UnallocatedValue | number:'1.2-2'}} {{group.Currency?.Name}}</span>
                    </div>
                  </div>
                  <i class="material-icons CGHeaderDelete" (click)="deleteGroup(group); $event.stopPropagation();" title="{{'Delete' | translate}}">close</i>
                </div>

                <!-- Group Body (expanded) -->
                <div class="CGBody" *ngIf="group.IsExpanded" (click)="$event.stopPropagation();">
                  <!-- Collection CCs -->
                  <div class="CGItem" *ngFor="let cc of group.Collections" [ngClass]="{'CGItemAssociated': cc.Status?.ID == 1, 'CGItemUnassociated': cc.Status?.ID == -1}">
                    <i class="material-icons CGItemIcon" [style.color]="cc.Status?.ID == 1 ? '#00c9bd' : '#f44336'">{{cc.Status?.ID == 1 ? 'receipt' : 'help_outline'}}</i>
                    <div class="CGItemInfo">
                      <span class="CGItemInvoice" *ngIf="cc.Status?.ID == 1">{{cc.DisplayValue}}</span>
                      <span class="CGItemInvoice CGItemUnassociatedText" *ngIf="cc.Status?.ID == -1 && cc.IsBufferCC">⟷ {{'Unallocated' | translate}}</span>
                      <span class="CGItemInvoice CGItemUnassociatedText" *ngIf="cc.Status?.ID == -1 && !cc.IsBufferCC">--- {{'Unallocated' | translate}}</span>
                      <span class="CGItemClient" *ngIf="cc.Client?.Name">{{cc.Client.Name}}</span>
                      <!-- Invoice total + dynamic remaining after this allocation -->
                      <div class="CGItemInvoiceValues" *ngIf="cc.Status?.ID == 1 && cc.InvoiceTotalValue > 0">
                        <span class="CGItemInvoiceTotal">Total: {{cc.InvoiceTotalValue | number:'1.2-2'}} {{cc.Currency?.Name}}</span>
                        <span class="CGItemDivider">·</span>
                        <span class="CGItemRemaining" *ngIf="(cc.CashCollectionRemainingValue - cc.Value) > 0.001">{{'RemainingToCashCollect' | translate}}: {{cc.CashCollectionRemainingValue - cc.Value | number:'1.2-2'}}</span>
                        <span class="CGItemRemaining CGItemRemainingComplete" *ngIf="(cc.CashCollectionRemainingValue - cc.Value) <= 0.001">{{'FullyCollected' | translate}}</span>
                      </div>
                    </div>
                    <!-- Editable value / invoice total for allocated CCs -->
                    <div class="CGItemValueGroup" *ngIf="cc.Status?.ID == 1">
                      <input type="text" class="CGItemValueInput CGItemValueInputOk" [value]="cc.Value" (change)="onAllocatedValueChange(group, cc, $event.target.value);" (click)="$event.stopPropagation();">
                      <span class="CGItemValueSeparator">/</span>
                      <span class="CGItemValueTotal" *ngIf="cc.InvoiceTotalValue > 0">{{cc.InvoiceTotalValue | number:'1.2-2'}}</span>
                      <span class="CGItemValueTotal CGItemValueTotalLoading" *ngIf="!cc.InvoiceTotalValue">--</span>
                      <span class="CGItemValueCurrency">{{cc.Currency?.Name}}</span>
                    </div>
                    <!-- Static value for unallocated / buffer CCs -->
                    <span *ngIf="cc.Status?.ID == -1" class="CGItemValue CGItemValueDanger">{{cc.Value | number:'1.2-2'}} {{cc.Currency?.Name}}</span>
                    <span class="CCRowBadge CCRowBadgeSuccess" *ngIf="cc.IsCompletingForInvoice" style="margin-left: 4px;">✓</span>
                    <div class="CGItemActions">
                      <i class="material-icons edit-action" *ngIf="cc.Status?.ID == 1" (click)="deallocateFromGroup(group, cc);" title="{{'Deallocate' | translate}}">link_off</i>
                      <i class="material-icons delete-action" *ngIf="!cc.IsBufferCC" (click)="deleteFromGroup(group, cc);" title="{{'Delete' | translate}}">close</i>
                    </div>
                  </div>

                  <!-- Allocate to Invoice button (always visible when group has unallocated value) -->
                  <div class="CGUnallocatedBar" *ngIf="group.UnallocatedValue > 0">
                    <i class="material-icons" style="color: #f60; font-size: 16px;">warning</i>
                    <span class="CGUnallocatedText">{{'Unallocated' | translate}}: <strong>{{group.UnallocatedValue | number:'1.2-2'}} {{group.Currency?.Name}}</strong></span>
                    <div class="CGUnallocatedActions">
                      <div class="CompactFilterButton" style="height: 26px; font-size: 10px; padding: 0 10px;" (click)="openGroupInvoiceSearch(group);">
                        <i class="material-icons" style="font-size: 14px;">add</i>
                        <span>{{'AllocateToInvoice' | translate}}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Uncollected Invoices List (inline) -->
                  <div class="CGInvoiceSearch" *ngIf="group.ShowInvoiceSearch">
                    <div class="CGSearchBar">
                      <i class="material-icons" style="color: #00c9bd; font-size: 16px;">receipt_long</i>
                      <span style="font-size: 11px; font-weight: 600; color: #1a3a5c; flex: 1;">{{'UnCollectedInvoices' | translate}}</span>
                      <i class="material-icons" style="color: #f44336; font-size: 16px; cursor: pointer;" (click)="group.ShowInvoiceSearch = false; groupInvoiceResults[group.GroupID] = null;">close</i>
                    </div>
                    <div class="CGSearchResults" *ngIf="groupInvoiceResults[group.GroupID]?.length > 0">
                      <div class="CGSearchResult" *ngFor="let inv of groupInvoiceResults[group.GroupID]" (click)="allocateInvoiceToGroup(group, inv);">
                        <i class="material-icons" style="color: #00c9bd; font-size: 16px;">receipt</i>
                        <span class="CGSearchResultInvoice">{{inv.AccountingNumber?.DisplayValue}}</span>
                        <span class="CGSearchResultClient">{{inv.Client?.Name}}</span>
                        <div class="CGSearchResultValues">
                          <span class="CGSearchResultValue">{{inv.Total?.TotalQtyPriceVAT | number:'1.2-2'}} {{inv.Currency?.Name}}</span>
                          <span class="CGSearchResultRemaining" *ngIf="inv.Details?.CashCollectionRemainingValue > 0">{{'RemainingToCashCollect' | translate}}: {{inv.Details?.CashCollectionRemainingValue | number:'1.2-2'}}</span>
                          <span class="CGSearchResultRemaining CGSearchResultRemainingComplete" *ngIf="inv.Details?.CashCollectionRemainingValue == 0">{{'FullyCollected' | translate}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="CGSearchNoResults" *ngIf="groupInvoiceResults[group.GroupID] != null && groupInvoiceResults[group.GroupID]?.length == 0">
                      <span style="color: #9ab5d0; font-size: 11px;">No invoices found</span>
                    </div>
                  </div>
                </div>
              </div>

              </ng-container>
            </ng-container>

            <div class="DetectedCCEmptyState" *ngIf="(activeDetectedTab === 'associated' && getGroupCountByStatus(1) === 0) || (activeDetectedTab === 'unassociated' && getGroupCountByStatus(-1) === 0)">
              <i class="material-icons">inbox</i>
              <span>0</span>
            </div>
          </div>
        </div>

        <!-- Totals + Accept Button -->
        <div style="padding: 12px 16px;">
          <div *ngIf="this.SuggestedCashCollections != null && this.SuggestedCashCollections.length > 0 && !loading;">
            <div class="CCTotalsRow" *ngFor="let Total of this.Totals;">
              <div style="display: flex; align-items: center; gap: 12px; width: 100%;">
                <span class="cc-total-label">{{this.SuggestedCashCollections.length}} {{'CashCollections' | translate}}</span>
                <span class="cc-total-label">Total:</span>
                <span class="cc-total-value">{{Total.UITotalQtyPriceVAT.Integer}}<span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></span>
                <span class="cc-total-currency">{{Total.Currency.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ConvertPopupFooter">
          <button class="ConvertPopupNoBtn" (click)="ShowSuggestionCashCollectionsContainer = false;">{{ 'Cancel' | translate }}</button>
          <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%) !important;" [disabled]="parent.loading" (click)="AcceptBankExtrasStepOne();">
            <i class="material-icons">chevron_right</i>
            {{'AcceptStep' | translate}}
          </button>
        </div>
      </div>

    <!-- Import Bank Extras Popup -->
    <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowBankExtrasImportContainer" (click)="ShowBankExtrasImportContainer = false;"></div>
    <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" *ngIf="ShowBankExtrasImportContainer">
      <div class="ConvertPopupHeader">
        <div class="ConvertPopupIconWrapper">
          <i class="material-icons">account_balance</i>
        </div>
        <div class="ConvertPopupHeaderText">
          <span class="ConvertPopupTitle">{{ 'ImportBankExtras' | translate }}</span>
        </div>
        <i class="material-icons ConvertPopupClose" (click)="ShowBankExtrasImportContainer = false;">close</i>
      </div>
      <div class="ConvertPopupBody" style="text-align: left; padding: 16px 20px;">
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'AccountNumber' | translate }}</label>
          <select class="PopupFormSelect" [(ngModel)]="ImportExtrasBankAccount" [compareWith]="compareFn">
            <option *ngFor="let b of this.BankAccounts" [ngValue]="b">{{b.DisplayValue}}</option>
          </select>
        </div>
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'UploadFile' | translate }}</label>
          <input type="file" class="PopupFormFileInput" (change)="onSelectFile($event)">
        </div>
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'Delimiter' | translate }}</label>
          <input type="text" class="PopupFormInput" placeholder=";" autocomplete="off" [(ngModel)]="this.ImportExtrasDelimiter">
          <i class="material-icons PopupFormInputIcon">code</i>
        </div>
      </div>
      <div class="ConvertPopupFooter">
        <button class="ConvertPopupNoBtn" (click)="ShowBankExtrasImportContainer = false;">{{ 'Cancel' | translate }}</button>
        <button class="ConvertPopupYesBtn" [disabled]="parent.loading" (click)="GetBankExtrasCashCollections();">
          <i class="material-icons">cloud_upload</i>
          {{'ImportDocument' | translate}}
        </button>
      </div>
    </div>

      <!-- Import Shipping Company Transfer List Popup -->
      <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowImportShippingCompanyTransferListContainer" (click)="ShowImportShippingCompanyTransferListContainer = false;"></div>
      <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" *ngIf="ShowImportShippingCompanyTransferListContainer">
        <div class="ConvertPopupHeader">
          <div class="ConvertPopupIconWrapper" style="background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);">
            <i class="material-icons">local_shipping</i>
          </div>
          <div class="ConvertPopupHeaderText">
            <span class="ConvertPopupTitle">{{ 'ImportShippingCompanyTransferList' | translate }}</span>
          </div>
          <i class="material-icons ConvertPopupClose" (click)="ShowImportShippingCompanyTransferListContainer = false;">close</i>
        </div>
        <div class="ConvertPopupBody" style="text-align: left; padding: 16px 20px;">
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'ShippingCompanies' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="ShippingCompany" [compareWith]="compareFn">
              <option *ngFor="let c of this.ShippingCompanies" [ngValue]="c">{{c.Name}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'Currency' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="ShippingTransferListCurrency" [compareWith]="compareFn" (change)="AdjustShippingTransferListBankAccount();">
              <option *ngFor="let c of this.Currencies" [ngValue]="c">{{c.Name}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'AccountNumber' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="ShippingTransferListBankAccount" [compareWith]="compareFn">
              <option *ngFor="let b of this.ShippingTransferListBankAccounts" [ngValue]="b">{{b.DisplayValue}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'UploadFile' | translate }}</label>
            <input type="file" class="PopupFormFileInput" (change)="onSelectFile($event)">
          </div>
        </div>
        <div class="ConvertPopupFooter">
          <button class="ConvertPopupNoBtn" (click)="ShowImportShippingCompanyTransferListContainer = false;">{{ 'Cancel' | translate }}</button>
          <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;" [disabled]="parent.loading" (click)="GetShippingCompanyTransferListCashCollections();">
            <i class="material-icons">cloud_upload</i>
            {{'ImportDocument' | translate}}
          </button>
        </div>
      </div>

    <!-- New / Edit Cash Collection Popup -->
    <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowCashCollectionContainer" (click)="ShowCashCollectionContainer = false;"></div>
    <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" style="width: 460px; left: calc(50% - 230px); top: 5%;" *ngIf="ShowCashCollectionContainer">
      <div class="ConvertPopupHeader">
        <div class="ConvertPopupIconWrapper">
          <i class="material-icons">{{this.currentCashCollettion.ID > 0 ? 'edit' : 'add_circle'}}</i>
        </div>
        <div class="ConvertPopupHeaderText">
          <span class="ConvertPopupTitle">{{(this.currentCashCollettion.ID > 0 ? 'UpdateCashCollection' : 'NewCashCollection') | translate}}</span>
        </div>
        <i class="material-icons ConvertPopupClose" (click)="ShowCashCollectionContainer = false;">close</i>
      </div>
      <div class="PopupScrollBody" style="padding: 16px 20px;">
        <!-- Associated Invoice Search -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'AssociatedInvoice' | translate }}*</label>
          <input *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0;" type="text" class="PopupFormInput" placeholder="{{'AssociatedInvoice' | translate}}" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue" (click)="SearchInvoices(this.currentCashCollettion.DisplayValue);" (keyup)="SearchInvoices(this.currentCashCollettion.DisplayValue);">
          <input *ngIf="this.currentCashCollettion?.InvoiceID?.length > 0;" type="text" class="PopupFormInput" disabled [(ngModel)]="this.currentCashCollettion.DisplayValue">
          <i class="material-icons PopupFormInputIconClickable" *ngIf="this.currentCashCollettion.InvoiceID?.length > 0;" (click)="this.currentCashCollettion.InvoiceID = '';this.currentCashCollettion.DisplayValue = '';this.currentCashCollettion.InvoiceDetailsID = null;">close</i>
          <i class="material-icons PopupFormInputIconClickable" *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0 && Invoices != null;" (click)="this.currentCashCollettion.DisplayValue = ''; Invoices = null">close</i>
        </div>
        <div class="InvoiceSearchContainer" *ngIf="Invoices != null;">
          <div class="InvoiceSearchResult" *ngFor="let i of this.Invoices;" (click)="SelectInvoiceForCashCollectionSearch(i);">
            <div class="InvoiceSearchResultCol">{{i.AccountingNumber.DisplayValue}}</div>
            <div class="InvoiceSearchResultCol" style="width: 40%;">{{i.Client.Name}}</div>
            <div class="InvoiceSearchResultCol">{{i.EventRegisterUIDate}}</div>
            <div class="InvoiceSearchResultCol">{{i.Total.TotalQtyPriceVAT}} {{i.Currency.Name}}</div>
          </div>
        </div>

        <!-- Associated Partner Search -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'AssociatedPartner' | translate }}*</label>
          <input *ngIf="!this.currentCashCollettion.Client?.ID?.length > 0;" type="text" class="PopupFormInput" placeholder="{{'AssociatedPartner' | translate}}" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.currentCashCollettion.Client = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;">
          <input *ngIf="this.currentCashCollettion?.Client?.ID?.length > 0;" type="text" class="PopupFormInput" disabled [(ngModel)]="this.currentCashCollettion.Client.Name">
          <i class="material-icons PopupFormInputIconClickable" *ngIf="this.currentCashCollettion.Client?.ID?.length > 0;" (click)="this.currentCashCollettion.Client = null;">close</i>
          <i class="material-icons PopupFormInputIconClickable" *ngIf="!this.currentCashCollettion.Client?.ID?.length > 0 && Partners != null;" (click)="this.currentCashCollettion.Client = null; Partners = null">close</i>
        </div>
        <div class="InvoiceSearchContainer" *ngIf="Partners != null;">
          <div class="InvoiceSearchResult" *ngFor="let p of this.Partners;" (click)="this.searchTerm = ''; this.currentCashCollettion.Client = p; Partners = null;">
            <div class="InvoiceSearchResultCol">{{p.Name}}</div>
            <div class="InvoiceSearchResultCol" style="width: 40%;"></div>
            <div class="InvoiceSearchResultCol"></div>
            <div class="InvoiceSearchResultCol"></div>
          </div>
        </div>

        <!-- CC Type -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'CashCollectionType' | translate }}</label>
          <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
            <option *ngFor="let type of this.CashCollectTypes" [ngValue]="type">{{type.Name}}</option>
          </select>
        </div>

        <!-- Currency -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'Currency' | translate }}</label>
          <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn" (change)="ReselectBankAccount(currentCashCollettion.Currency);">
            <option *ngFor="let c of this.Currencies" [ngValue]="c">{{c.Name}}</option>
          </select>
        </div>

        <!-- Bank Account -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'AccountNumber' | translate }}</label>
          <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
            <option *ngFor="let b of this.BankAccounts" [ngValue]="b">{{b.DisplayValue}}</option>
          </select>
        </div>

        <!-- Exchange Rate -->
        <div class="PopupFormRow" *ngIf="this.currentCashCollettion.Currency?.ExchangeRate > 0;">
          <label class="PopupFormLabel">{{ 'Receptions.ExchangeRate' | translate }}</label>
          <input type="text" class="PopupFormInput" placeholder="1.0000" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
        </div>

        <!-- Decimal Precision -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'Receptions.DecimalPercision' | translate }}</label>
          <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
            <option *ngFor="let d of this.DecimalPrecisions" [ngValue]="d">{{d.Meaning}}</option>
          </select>
        </div>

        <!-- Collection Date (keep mat-datepicker for date picking) -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'CollectionDate' | translate }}</label>
          <mat-form-field appearance="outline" style="width: 100%;">
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Value -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency?.Name}}]</label>
          <input type="text" class="PopupFormInput" placeholder="0.00" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
          <i class="material-icons PopupFormInputIcon">monetization_on</i>
        </div>

        <!-- External ID -->
        <div class="PopupFormRow">
          <label class="PopupFormLabel">{{ 'CollectionExternalID' | translate }}</label>
          <input type="text" class="PopupFormInput" placeholder="" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
          <i class="material-icons PopupFormInputIcon">qr_code_2</i>
        </div>
      </div>

      <div class="ConvertPopupFooter" style="flex-wrap: wrap; gap: 8px;">
        <button class="ConvertPopupNoBtn" (click)="ShowCashCollectionContainer = false;">{{ 'Cancel' | translate }}</button>
        <button class="ConvertPopupYesBtn" *ngIf="this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" (click)="UpdateCashCollection(this.currentCashCollettion);ShowCashCollectionContainer = false;">
          <i class="material-icons">save</i> {{'UpdateCashCollection' | translate}}
        </button>
        <button class="ConvertPopupYesBtn" *ngIf="!this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" (click)="AddCashCollection();ShowCashCollectionContainer = false;">
          <i class="material-icons">check</i> {{'Collect' | translate}}
        </button>
        <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%) !important;" *ngIf="!this.currentCashCollettion.ID > 0;" [disabled]="parent.loading" (click)="AllocateCashCollection();ShowCashCollectionContainer = false;" title="{{'ProofInvoiceSUMSDescription' | translate}}">
          <i class="material-icons">auto_fix_high</i> {{'AllocateCashCollection' | translate}}
        </button>
      </div>
    </div>

      <!-- Suggested CC Modifier Popup -->
      <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowSuggestedCashCollectionModifier" (click)="ShowSuggestedCashCollectionModifier = false;"></div>
      <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" style="width: 460px; left: calc(50% - 230px); top: 8%;" *ngIf="ShowSuggestedCashCollectionModifier">
        <div class="ConvertPopupHeader">
          <div class="ConvertPopupIconWrapper" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%);">
            <i class="material-icons">edit</i>
          </div>
          <div class="ConvertPopupHeaderText">
            <span class="ConvertPopupTitle">{{(this.currentCashCollettion.ID > 0 ? 'UpdateCashCollection' : 'NewCashCollection') | translate}}</span>
          </div>
          <i class="material-icons ConvertPopupClose" (click)="ShowSuggestedCashCollectionModifier = false;">close</i>
        </div>
        <div class="PopupScrollBody" style="padding: 16px 20px;">
          <!-- Invoice Search -->
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'AssociatedInvoice' | translate }}*</label>
            <input *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0;" type="text" class="PopupFormInput" placeholder="{{'AssociatedInvoice' | translate}}" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue" (click)="SearchInvoices(this.currentCashCollettion.DisplayValue);" (keyup)="SearchInvoices(this.currentCashCollettion.DisplayValue);">
            <input *ngIf="this.currentCashCollettion.InvoiceID?.length > 0;" type="text" class="PopupFormInput" disabled [(ngModel)]="this.currentCashCollettion.DisplayValue">
            <i class="material-icons PopupFormInputIconClickable" *ngIf="this.currentCashCollettion.InvoiceID?.length > 0;" (click)="this.currentCashCollettion.InvoiceID = '';this.currentCashCollettion.DisplayValue = '';DeallocateInvoiceFromCC();">close</i>
            <i class="material-icons PopupFormInputIconClickable" *ngIf="!this.currentCashCollettion.InvoiceID?.length > 0 && Invoices != null;" (click)="this.currentCashCollettion.DisplayValue = ''; Invoices = null; DeallocateInvoiceFromCC();">close</i>
          </div>
          <div class="InvoiceSearchContainer" *ngIf="Invoices != null;">
            <div class="InvoiceSearchResult" *ngFor="let i of this.Invoices;" (click)="SelectInvoiceForCashCollectionSearch(i);">
              <div class="InvoiceSearchResultCol">{{i.AccountingNumber.DisplayValue}}</div>
              <div class="InvoiceSearchResultCol" style="width: 40%;">{{i.Client.Name}}</div>
              <div class="InvoiceSearchResultCol">{{i.EventRegisterUIDate}}</div>
              <div class="InvoiceSearchResultCol">{{i.Total.TotalQtyPriceVAT}} {{i.Currency.Name}}</div>
            </div>
          </div>

          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'CashCollectionType' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
              <option *ngFor="let type of this.CashCollectTypes" [ngValue]="type">{{type.Name}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'Currency' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn" (change)="ReselectBankAccount(currentCashCollettion.Currency);">
              <option *ngFor="let c of this.Currencies" [ngValue]="c">{{c.Name}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'AccountNumber' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
              <option *ngFor="let b of this.BankAccounts" [ngValue]="b">{{b.DisplayValue}}</option>
            </select>
          </div>
          <div class="PopupFormRow" *ngIf="this.currentCashCollettion.Currency?.ExchangeRate > 0;">
            <label class="PopupFormLabel">{{ 'Receptions.ExchangeRate' | translate }}</label>
            <input type="text" class="PopupFormInput" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'Receptions.DecimalPercision' | translate }}</label>
            <select class="PopupFormSelect" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
              <option *ngFor="let d of this.DecimalPrecisions" [ngValue]="d">{{d.Meaning}}</option>
            </select>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'CollectionDate' | translate }}</label>
            <mat-form-field appearance="outline" style="width: 100%;">
              <input matInput [matDatepicker]="dp4" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
              <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
              <mat-datepicker #dp4></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency?.Name}}]</label>
            <input type="text" class="PopupFormInput" placeholder="0.00" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
            <i class="material-icons PopupFormInputIcon">monetization_on</i>
          </div>
          <div class="PopupFormRow">
            <label class="PopupFormLabel">{{ 'CollectionExternalID' | translate }}</label>
            <input type="text" class="PopupFormInput" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
            <i class="material-icons PopupFormInputIcon">qr_code_2</i>
          </div>
        </div>
        <div class="ConvertPopupFooter">
          <button class="ConvertPopupNoBtn" (click)="ShowSuggestedCashCollectionModifier = false;">{{ 'Cancel' | translate }}</button>
          <button class="ConvertPopupYesBtn" [disabled]="parent.loading" (click)="ShowSuggestedCashCollectionModifier = false;">
            <i class="material-icons">save</i> {{'UpdateCashCollection' | translate}}
          </button>
        </div>
      </div>

    <!-- Delete Confirmation Popup -->
    <div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowDeleteSpendingQuestion" (click)="ShowDeleteSpendingQuestion = false; currentCashCollettion = null;"></div>
    <div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" *ngIf="ShowDeleteSpendingQuestion">
      <div class="ConvertPopupHeader">
        <div class="ConvertPopupIconWrapper" style="background: linear-gradient(135deg, #ff3b30 0%, #cc2f26 100%);">
          <i class="material-icons">delete</i>
        </div>
        <div class="ConvertPopupHeaderText">
          <span class="ConvertPopupTitle">{{ 'Configuration.DeleteQuestion' | translate }}</span>
        </div>
        <i class="material-icons ConvertPopupClose" (click)="ShowDeleteSpendingQuestion = false; currentCashCollettion = null;">close</i>
      </div>
      <div class="ConvertPopupBody">
        <p class="ConvertPopupMessage">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
      </div>
      <div class="ConvertPopupFooter">
        <button class="ConvertPopupNoBtn" [disabled]="this.parent.loading" (click)="ShowDeleteSpendingQuestion = false; currentCashCollettion = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #ff3b30 0%, #cc2f26 100%);" [disabled]="this.parent.loading" (click)="ShowDeleteSpendingQuestion = false;DeleteCashCollection(currentCashCollettion.ID);">
          <i class="material-icons">delete</i>
          {{ 'Configuration.DeleteYesButton' | translate }}
        </button>
      </div>
    </div>

    <div class="overlay" *ngIf="showEditSpendingPopUp;" (click)="showEditSpendingPopUp = false;"></div>

    <!-- Advanced Filters Row (inline, compact) -->
    <div class="AdvancedFiltersRow">
      <div class="FilterGrid">
        <!-- Doc Status -->
        <div class="CustomDropdownContainer">
          <div class="CustomDropdownBar" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons dropdown-icon-left">description</i>
            <span class="CustomDropdownInput" [class.placeholder]="!Filter.DocumentStatus?.Name">{{Filter.DocumentStatus?.Name || 'Doc.Status'}}</span>
            <i class="material-icons dropdown-clear" *ngIf="Filter.DocumentStatus?.Name" (click)="Filter.DocumentStatus = null; RemoveActiveFilter('', 'DocStatus'); $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!Filter.DocumentStatus?.Name">expand_more</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showFilter">
            <div class="CustomDropdownResult" *ngFor="let d of this.DocumentStatuses" (click)="Filter.DocumentStatus = d; AddActiveFilter(d.Name, 'DocStatus'); showFilter = false; GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{d.Name}}</span></div>
            </div>
          </div>
        </div>

        <!-- Currency -->
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showCurrencyDropdown" (click)="showCurrencyDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showCurrencyDropdown = !showCurrencyDropdown;">
            <i class="material-icons dropdown-icon-left">euro</i>
            <span class="CustomDropdownInput" [class.placeholder]="!Filter.Currency?.Name">{{Filter.Currency?.Name || ('Currency' | translate)}}</span>
            <i class="material-icons dropdown-clear" *ngIf="Filter.Currency?.Name" (click)="Filter.Currency = null; RemoveActiveFilter('', 'Currency'); $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!Filter.Currency?.Name">expand_more</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showCurrencyDropdown">
            <div class="CustomDropdownResult" *ngFor="let c of this.Currencies" (click)="Filter.Currency = c; AddActiveFilter(c.Name, 'Currency'); showCurrencyDropdown = false; GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
            </div>
          </div>
        </div>

        <!-- Bank Account -->
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showBankDropdown" (click)="showBankDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showBankDropdown = !showBankDropdown;">
            <i class="material-icons dropdown-icon-left">account_balance</i>
            <span class="CustomDropdownInput" [class.placeholder]="!Filter.BankAccount?.DisplayValue">{{Filter.BankAccount?.DisplayValue || ('AccountNumber' | translate)}}</span>
            <i class="material-icons dropdown-clear" *ngIf="Filter.BankAccount?.DisplayValue" (click)="Filter.BankAccount = null; RemoveActiveFilter('', 'BankAccount'); $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!Filter.BankAccount?.DisplayValue">expand_more</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showBankDropdown">
            <div class="CustomDropdownResult" *ngFor="let b of this.BankAccounts" (click)="Filter.BankAccount = b; AddActiveFilter(b.DisplayValue, 'BankAccount'); showBankDropdown = false; GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{b.DisplayValue}}</span></div>
            </div>
          </div>
        </div>

        <!-- CC Type -->
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showTypeDropdown" (click)="showTypeDropdown = false"></div>
          <div class="CustomDropdownBar" (click)="showTypeDropdown = !showTypeDropdown;">
            <i class="material-icons dropdown-icon-left">category</i>
            <span class="CustomDropdownInput" [class.placeholder]="!Filter.Type?.Name">{{Filter.Type?.Name || ('CashCollectionType' | translate)}}</span>
            <i class="material-icons dropdown-clear" *ngIf="Filter.Type?.Name" (click)="Filter.Type = null; RemoveActiveFilter('', 'Type'); $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!Filter.Type?.Name">expand_more</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showTypeDropdown">
            <div class="CustomDropdownResult" *ngFor="let t of this.CashCollectTypes" (click)="Filter.Type = t; AddActiveFilter(t.Name, 'Type'); showTypeDropdown = false; GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{t.Name}}</span></div>
            </div>
          </div>
        </div>

        <!-- Partner Search -->
        <div class="CustomDropdownContainer">
          <div class="CustomDropdownBar">
            <i class="material-icons dropdown-icon-left">person_search</i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!searchTerm" placeholder="{{'SearchClient' | translate}}" [(ngModel)]="searchTerm" (ngModelChange)="searchPartnerUpdate.next($event)" (click)="$event.stopPropagation();">
            <i class="material-icons dropdown-clear" *ngIf="searchTerm" (click)="searchTerm=''; this.Partners = []; resultsLength = 0; Filter.Partner = null; $event.stopPropagation();">close</i>
            <i class="material-icons dropdown-icon" *ngIf="!searchTerm">search</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="resultsLength > 0">
            <div class="CustomDropdownResult" *ngFor="let p of Partners" (click)="resultsLength = 0; searchTerm = p.Name; Filter.Partner = p; AddActiveFilter(p.Name, 'Partner'); GetCashCollectionsFiltered();">
              <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length">{{p.VAT}}</span></span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="ActiveFiltersContainer" *ngIf="this.activeFilters?.length > 0">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <!-- Pagination Row -->
    <div class="ProductsPaginationRow">
      <div class="PaginationInfo">
        <span>{{this.CashCollections?.length}} {{'OfWord' | translate}} {{this.Filter?.Pager?.TotalCount}} {{'CashCollections' | translate}}</span>
      </div>
      <div class="PaginationControls">
        <div class="PaginationButton" [class.disabled]="this.Filter.Pager.PageIndex == 1" [attr.disabled]="this.Filter.Pager.PageIndex == 1 ? true : null" (click)="this.Filter.Pager.PageIndex != 1 && GetCashCollectionsFiltered(this.Filter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </div>
        <div class="PageNumberDisplay">
          <span>{{this.Filter?.Pager?.PageIndex}}</span> / <span>{{this.Filter?.Pager?.Pages}}</span>
        </div>
        <div class="PaginationButton" [class.disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" [attr.disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages ? true : null" (click)="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages && GetCashCollectionsFiltered(this.Filter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>
      <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="GetCashCollectionsFiltered(1);" title="{{'PageSize' | translate}}">
    </div>

    <!-- Orders Body - OrderCardRow Design -->
    <div class="OrdersBody" style="padding: 0 12px;">

      <div style="text-align:center;padding:30px;" *ngIf="loading">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
      </div>

      <div *ngIf="!loading">
        <div class="OrderCardRow" *ngFor="let c of this.CashCollections; let i=index;" [ngClass]="{'OrderCardRowUnassociated': c.Status.ID == -1}" (dblclick)="CloneCashCollection(c); ShowCashCollectionContainer = true;">
          <!-- Invoice & Status -->
          <div class="OrderRowSection">
            <i class="material-icons" style="color: #00c9bd;" *ngIf="c.Status.ID == 1;">receipt</i>
            <i class="material-icons" style="color: #f44336;" *ngIf="c.Status.ID == -1;">help_outline</i>
            <span class="OrderRowIndex">#{{i + 1}}</span>
            <div class="OrderRowContent">
              <span class="OrderRowLabel">{{'Invoice' | translate}}</span>
              <span class="OrderRowValue" *ngIf="c.Status.ID == 1;" style="color: #00a79d; font-weight: 700;">{{c.DisplayValue}}</span>
              <span class="OrderRowValue" *ngIf="c.Status.ID == -1;" style="color: #f44336; font-style: italic;">---</span>
            </div>
          </div>

          <!-- Client -->
          <div class="OrderRowSection">
            <i class="material-icons">business</i>
            <div class="OrderRowContent">
              <span class="OrderRowLabel">{{'Client' | translate}}</span>
              <span class="OrderRowValue" *ngIf="c.Client?.ID?.length > 0;">{{c.Client.Name}}</span>
              <span class="OrderRowValue" *ngIf="!(c.Client?.ID?.length > 0)" style="color: #f44336; font-style: italic;">[ {{c.Status.Name}} ]</span>
            </div>
          </div>

          <!-- Date -->
          <div class="OrderRowSection">
            <i class="material-icons">event</i>
            <div class="OrderRowContent">
              <span class="OrderRowLabel">{{'CashColletcionDate' | translate}}</span>
              <span class="OrderRowValue">{{c.CollectionDateUI}}</span>
            </div>
          </div>

          <!-- Value -->
          <div class="OrderRowSection">
            <div class="OrderRowContent">
              <span class="OrderRowLabel">{{'Value' | translate}}</span>
              <span class="OrderRowValue OrderRowValueBold">{{c.Value}} {{c.Currency.Name}}</span>
            </div>
          </div>

          <!-- Type + External ID -->
          <div class="OrderRowSection">
            <div class="OrderRowContent">
              <span class="OrderRowLabel">{{'CashCollectionType' | translate}}</span>
              <span class="OrderRowValue">{{c.Type.Name}}</span>
              <div class="OrderRowMeta" *ngIf="c.CollectionExternalID">
                <span style="font-size: 9px; color: #9ab5d0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; display: inline-block;">{{c.CollectionExternalID}}</span>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="OrderRowSection OrderRowActions">
            <i class="material-icons" style="color: #00c9bd; cursor: pointer; font-size: 20px; transition: all 0.2s;" (click)="CloneCashCollection(c); ShowCashCollectionContainer = true;" title="{{'Edit' | translate}}">edit</i>
            <i class="material-icons" style="color: #f44336; cursor: pointer; font-size: 20px; transition: all 0.2s;" (click)="CloneCashCollection(c); ShowDeleteSpendingQuestion = true;" title="{{'Delete' | translate}}">delete</i>
          </div>
        </div>
      </div>

      <!-- Totals -->
      <div *ngIf="this.CashCollections != null && this.CashCollections.length > 0 && !loading;">
        <div class="CCTotalsRow" *ngFor="let Total of this.Totals;">
          <div style="display: flex; align-items: center; gap: 12px; width: 100%;">
            <span class="cc-total-label">Total:</span>
            <span class="cc-total-value">{{Total.UITotalQtyPriceVAT.Integer}}<span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></span>
            <span class="cc-total-currency">{{Total.Currency.Name}}</span>
          </div>
        </div>
      </div>

    </div>

</div>